export const Header = () => (
  <h1>
    Поделитесь своим мнением о нашем магазине
  </h1>
)